import { render, staticRenderFns } from "./companyInformation.vue?vue&type=template&id=152a73ac&scoped=true"
import script from "./companyInformation.vue?vue&type=script&lang=js"
export * from "./companyInformation.vue?vue&type=script&lang=js"
import style0 from "./companyInformation.vue?vue&type=style&index=0&id=152a73ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152a73ac",
  null
  
)

export default component.exports